import { ReactElement } from 'react'
import AppBar from '@mui/material/AppBar'
import CssBaseline from '@mui/material/CssBaseline'
import Toolbar from '@mui/material/Toolbar'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { always, ifElse, equals } from 'ramda'

interface Props {
  children: ReactElement | ReactElement[]
  title: string
  requireAuth?: boolean
}

let UnauthenticatedLayout = ({
  title,
  children,
  requireAuth = false,
}: Props): ReactElement => (
  <>
    <CssBaseline />
    <AppBar
      color="inherit"
      position="static"
      sx={{
        borderBottom: '1px solid white',
        backgroundColor: (theme) => theme.palette.background.default,
      }}
    >
      <Toolbar>
        <Typography variant="h6" noWrap>
          {title}
        </Typography>
      </Toolbar>
    </AppBar>
    {ifElse(
      equals(false),
      // Explicitly set `requireAuth` to false to get the unauth page layout
      always(
        <Paper sx={{ margin: 3 }}>
          <Box sx={{ flexGrow: 1, padding: 3 }}>{children}</Box>
        </Paper>,
      ),
      // Sign-in page will never have `requireAUth` explicitly set
      always(children),
    )(requireAuth)}
  </>
)

export default UnauthenticatedLayout
